import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InfoDialog from '../Dialog/InfoDialog';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  infoCard: {
    width: '100%',
    height: 86,
    padding: "16px",
    display: 'flex',
    alignItems: 'center',
  },
  infoCardTitle: {
    color: '#6b778c',
    fontSize: 14,
    //textTransform: 'uppercase',
    fontWeight: 600,
    letterSpacing: 'normal'
  },
  infoCardSecondTitle: {
    color: '#6b778c',
    fontSize: 12,
    //textTransform: 'uppercase',
    fontWeight: 600,
    letterSpacing: 'normal'
  },
  infoCardIcon: {
    fontSize: 14,
    margin: '-2px 3px 0px 3px',
    color: '#A8A8A8',
    //float: 'right',
    cursor: 'pointer'
    // marginTop: 4
  },
  value: {
    fontSize: 20,
    //textTransform: 'uppercase',
    fontWeight: 300,
    textAlign: 'right'
    //float:'right'
  },
  first: {
    //width:'100%'
  },
  last: {
    //width:'70%'
    marginLeft: 'auto'
  }
}));
const InfoCard = (props) => {
  const { title,title1,bg, value,value1, color,color1, infoIcon, infoTitle, infoText } = props;
  const classes = useStyles();
  const [infoOpen, setInfoOpen] = React.useState(false);
  const handleInfoOpen = () => {
    setInfoOpen(true);
  }
  const handleInfoClose = () => {
    setInfoOpen(false);
  }
  return (
    <>
      <Paper className={classes.infoCard} style={{ backgroundColor: bg ? bg : 'inherit' }} >
        <div className={classes.first}>
          <Typography variant="subtitle2" className={classes.infoCardTitle}>
            {title}
          </Typography>
          <Typography variant="subtitle2" className={classes.value} style={{ color: color ? color : 'inherit' }}>
            {value?value:'N/A'}
          </Typography>
        </div>
        <div className={classes.last}>
          <Typography variant="subtitle2" className={classes.infoCardSecondTitle}>
            {title1}
          </Typography>
          <Typography variant="subtitle2" className={classes.value} style={{ color: color1 ? color1 : 'inherit' }}>
            {value1}
          </Typography>
        </div>

        {/* <Typography variant="subtitle2" className={classes.infoCardTitle}>
            {title}<span>{infoIcon && <InfoOutlinedIcon onClick={handleInfoOpen} className={classes.infoCardIcon} />}</span>
            <Typography variant="subtitle2" className={classes.value} style={{color:color?color:'inherit'}}>
            {cardValue}
            </Typography>
            </Typography> */}
        {/* <Typography variant="subtitle2" className={classes.value} style={{color:color?color:'inherit'}}>
            {cardValue}
            </Typography> */}
      </Paper>
      {infoOpen && <InfoDialog confirmOpen={infoOpen} confirmTitle={infoTitle} confirmMessage={infoText} onClose={handleInfoClose} />}
    </>
  );
}
export default InfoCard;